import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ServicesSection.css";

const ServicesSection = () => {
  const services = [
    {
      title: "Pune to Nasik Cabs Hire",
      description:
        "Sai Trupti Cab offers reliable and affordable cab hire services with experienced drivers and well-maintained vehicles. Whether you are traveling for business, leisure, or pilgrimage, enjoy a safe and comfortable journey with us.",
      image: "/images/keyword/34.jpg",
      link: "/booking",
    },
    {
      title: "Mumbai to Pune Online Cab",
      description:
        "Sai Trupti Cabs offers a seamless online cab booking experience for your journey from Mumbai to Pune. Our user-friendly platform allows you to book a cab in just a few clicks—whether it’s a one-way trip, or outstation ride.",
      image: "/images/keyword/65.jpg",
      link: "/booking",
    },
    {
      title: "Pune to Shirdi Cabs Hire",
      description:
        "Sai Trupti Cabs offers comfortable and affordable cab hire services with experienced drivers and well-maintained vehicles. Whether you’re visiting for pilgrimage or leisure, travel safely and conveniently with us.",
      image: "/images/newimages/7.jpg",
      link: "/booking",
    },
    {
      title: "Viman Nagar to Mumbai Cabs",
      description:
        "Travel comfortably from Viman Nagar to Mumbai with Sai Trupti Cab. We offer a variety of vehicles including sedans, SUVs, and luxury cars to suit your travel needs.",
      image: "/images/keyword/23.jpg",
      link: "/booking",
    },
    {
      title: "Mumbai to Pune One Way Cab",
      description:
        "Sai Trupti Cabs offers seamless one-way travel solutions at competitive prices. Whether you are traveling for work, education, or family visits, we ensure a safe and reliable ride.",
      image: "/images/keyword/53.jpg",
      link: "/booking",
    },
    {
      title: "Andheri to Pune Cab",
      description:
        "Whether you’re traveling for business, leisure, or family visits, our well-maintained cars and professional drivers ensure a safe ride on the Mumbai–Pune Expressway.",
      image: "/images/keyword/57.jpg",
      link: "/booking",
    },
  ];

  return (

<>


 <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Services</h1>
          </div>
        </div>
      </section>


    <section className="services-section py-5">
      <div className="container">
        <div className="row">
          {services.map((service, index) => (
            <div key={index} className="col-md-4 mb-4">
              <div className="service-card shadow-sm h-100">
                <img src={service.image} alt={service.title} className="img-fluid" />
                <div className="p-3">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-desc">{service.description}</p>
                  <a href={service.link} className="book-btn btn btn-warning w-100">
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

</>
  );
};

export default ServicesSection;
